import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { UserLocalSelectionService } from 'src/app/services/dataServices/user-local-selection-service/user-local-selection.service';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { throwError, of } from 'rxjs';
import { catchError, retry, switchMap, finalize } from 'rxjs/operators';

@Component({
    selector: 'app-abo-confirmation',
    templateUrl: './abo-confirmation.component.html',
    styleUrls: ['./abo-confirmation.component.scss'],
    standalone: false
})
export class AboConfirmationComponent implements OnInit {
  orgId: number;

  constructor(public organisationService: OrganisationService, 
    private localSelectionService: UserLocalSelectionService, 
    private stripeService: StripeService,
    private dialogService: DialogService,
    private router: Router) { }

  ngOnInit(): void {
    this.localSelectionService.clearSelection('selectedPackage-register');

    if (this.organisationService?.activeItem) {
      this.orgId = this.organisationService.activeItem.organisationId;

      this.stripeService.registerSubscriptionInDB(this.orgId).pipe(
        retry(1),
        switchMap(registerResponse => {
          if (typeof registerResponse === 'object' && registerResponse.status !== undefined) {
            return throwError(() => new Error(registerResponse.message));
          }
          return this.stripeService.updateStripeUserDateBecauseNewPayment(this.orgId).pipe(retry(1));
        }),
        catchError(err => {
          this.showErrorDialog();
          return of(null);
        })
      ).subscribe();
    }
  }

  private showErrorDialog(): void {
    this.dialogService.openDialog(
      'Ein Fehler ist aufgetreten',
      'Leider konnte die Bestätigung Ihres Abonnements nicht abgeschlossen werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an unseren Kundenservice.'
    ).subscribe(() => {
      this.router.navigate(['organisations/' + this.orgId + '/information']);
    });
  }

}
